import {mapActions, mapGetters, mapMutations} from 'vuex'

export const pluginMixin = {
  computed: {
    ...mapGetters({
      'plugins': 'plugins/all'
      // 'plugin': 'plugins/plugin'
    })
  },
  methods: {
    ...mapActions({
      'getPlugins': 'plugins/getPlugins',
      'addSinglePlugin': 'plugins/addPlugin'
    }),
    ...mapMutations({
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pluginMixin.js